module.exports = __webpack_public_path__ + "img/kuaishou.909a9d71.png";